import React, { useEffect, useState } from "react"
import ProfileTabs from "../components/ProfileTabs"
import { useAuth } from "../context/authContext"
import { getUserData } from "../firebase/users"
import { getSentOffersByUserId, getReceivedOffersByUserId, updateOffer } from "../firebase/offers"
import { formatDate } from "../utils"
import { Link } from "react-router-dom"
import DialogConfirmation from "../components/dialogs/DialogConfirmation"
import Pagination from "../components/commons/Pagination"
import { getPurchasedListings, getSoldListings, debugSalesData } from "../firebase/sales"
import DialogShippingTracking from "../components/dialogs/DialogShippingTracking"
import { getListingByID } from "../firebase/listings"
import { getShopifyProductByID, getStoreOwnerUid } from "../firebase/shopify"
import { recipientIdAtom, showIndividualMessageBoxAtom } from "../store"
import DialogReceipt from "../components/dialogs/DialogReceipt"

import { useAtom } from "jotai"
import ProfileTitle from "../components/ProfileTitle"

// A sale's cardId can point at either a regular listing or a Shopify
// product -- the two live in different collections, so a sale row has to
// try both instead of assuming one.
const getSaleItemDetails = async (cardId) => {
    const listing = await getListingByID(cardId)
    if (listing) return listing
    return await getShopifyProductByID(cardId)
}

const fields = [
    "Order Number", "Title", "Quantity", "Date", "Price", "Status", "Shipping", "Actions"
]

const formatSaleNumber = (num) => {
    const n = Number.isFinite(Number(num)) ? Number(num) : 0;
    return `#${String(n).padStart(6, "0")}`;
};

const itemsPerPage = 4

const SentItem = ({ item, activeTab, onOpenReceipt }) => {
    const [card, setCard] = useState(null)
    const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
    const [recipientId, setRecipientId] = useAtom(recipientIdAtom)
    const [showShippingDialog, setShowShippingDialog] = useState(false)

    useEffect(() => {
        getSaleItemDetails(item.cardId).then((data) => {
            setCard(data)
        })
    }, [])

    const setMessageToSeller = async () => {
        // On a Shopify sale `receiver` is the store's role id, which has no
        // inbox -- the buyer's "Chat" has to reach the store's owner.
        const sellerUid = item.source === 'shopify'
            ? await getStoreOwnerUid(item.shopify_store_domain || item.shop_domain || '')
            : item.receiver

        setRecipientId(activeTab === 'sold' ? item.sender : (sellerUid || item.receiver))
        setShowIndividualMessageBox(true)
    }

    const showReceipt = () => {
        onOpenReceipt(item, card)
    }

    return (
        card &&
        <tr className="border-[1px] border-gray text-nowrap">
            <td className="lg:min-w-[100px] pr-4 text-center">
                {formatSaleNumber(item?.number)}
            </td>

            <td className="py-2 pl-3 pr-20 lg:min-w-[250px] min-w-[200px]">
                <div className="flex items-center">
                    <img
                        src={card.pictures[0]}
                        alt="picture"
                        className="w-[50px] h-[50px] mr-6 object-cover bg-white border-[1px] border-gray"
                    />

                    <span className="uppercase text-sm">
                        {card.title}
                    </span>
                </div>
            </td>
            
            <td className="lg:min-w-[100px] pr-4">
                {item.count || 1}
            </td>

            <td className="lg:min-w-[150px] pr-4">
                {formatDate(item.created_at.seconds)}
            </td>

            <td className="lg:min-w-[100px] pr-4">
                $ {(item.offer_price || item.price || card.price || 0).toFixed(2)}
            </td>

                                  <td className="lg:min-w-[120px] pr-4">
                        <span className="px-2 py-1 rounded text-xs bg-green-500 text-white">
                          Completed
                        </span>
                      </td>

            <td className="lg:min-w-[120px] pr-4">
                {item.shipping ? (
                    <span className={`px-2 py-1 rounded text-xs ${
                        item.shipping.status === 'delivered' ? 'bg-green-500 text-white' :
                        item.shipping.status === 'shipped' ? 'bg-blue-500 text-white' :
                        item.shipping.status === 'in_transit' ? 'bg-orange-500 text-white' :
                        'bg-gray-500 text-white'
                    }`}>
                        {item.shipping.status}
                    </span>
                ) : (
                    <span className="px-2 py-1 rounded text-xs bg-gray-500 text-white">
                        No Shipping
                    </span>
                )}
            </td>

            <td className="pr-3">
                <div className="flex flex-col space-y-2">
                    <button className="solo-button flex justify-center items-center text-white border-white border-[1px] bg-primary w-[120px] h-[35px] text-xs" onClick={setMessageToSeller}>
                        <img src="/assets/icons/icon-message.svg" alt="message" className="mr-1 mt-[2px]" />Chat
                    </button>

                    <button
                        className="solo-button text-white border-[1px] border-gray w-[120px] h-[35px] text-xs"
                        onClick={showReceipt}>
                        Receipt
                    </button>

                    {/* Shipping Tracking Button */}
                    {(item.shipping || item.tracking_number) && (
                        <button 
                            onClick={() => setShowShippingDialog(true)}
                            className="text-blue-500 border-[1px] border-blue-500 w-[120px] h-[35px] hover:bg-blue-500 hover:text-white text-xs"
                        >
                            Track Shipping
                        </button>
                    )}

                    {/* Add Tracking Button for Sellers (Legacy) */}
                    {activeTab === 'sold' && !item.shipping && (
                        <button 
                            onClick={() => {
                                console.log('Opening shipping dialog for item:', item);
                                setShowShippingDialog(true);
                            }}
                            className="text-blue-500 border-[1px] border-blue-500 w-[120px] h-[35px] hover:bg-blue-500 hover:text-white text-xs"
                        >
                            Add Tracking
                        </button>
                    )}




                </div>

                {/* Shipping Tracking Dialog */}
                {showShippingDialog && (
                    <DialogShippingTracking
                        isOpen={showShippingDialog}
                        onClose={() => setShowShippingDialog(false)}
                        saleData={item}
                        userRole={activeTab === 'purchased' ? 'buyer' : 'seller'}
                    />
                )}
            </td>
        </tr>
    )
}

const MobileSentItem = ({ item, activeTab, onOpenReceipt }) => {
    const [card, setCard] = useState(null)
    const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
    const [recipientId, setRecipientId] = useAtom(recipientIdAtom)
    const [showShippingDialog, setShowShippingDialog] = useState(false)

    useEffect(() => {
        getSaleItemDetails(item.cardId).then((data) => {
            setCard(data)
        })
    }, [])

    const setMessageToSeller = async () => {
        // On a Shopify sale `receiver` is the store's role id, which has no
        // inbox -- the buyer's "Chat" has to reach the store's owner.
        const sellerUid = item.source === 'shopify'
            ? await getStoreOwnerUid(item.shopify_store_domain || item.shop_domain || '')
            : item.receiver

        setRecipientId(activeTab === 'sold' ? item.sender : (sellerUid || item.receiver))
        setShowIndividualMessageBox(true)
    }

    const showReceipt = () => {
        onOpenReceipt(item, card)
    }

    return (
        card &&
        <div className="p-[10px] border-[1px] border-gray bg-[#191919]">
            <div className="flex w-full">
                <img src={card.pictures[0]} className="w-[113px] h-[113px] object-cover bg-white border-[1px] border-gray mr-4" alt="image" />

                <div className="w-full mb-9">
                    <div className="uppercase text-white text-sm">{card.title}</div>

                    <div className="mt-4 w-full flex justify-between text-[#717171] text-xs">
                        <span>Price</span>
                        <span className="text-white">$ {(item.offer_price || item.price || 0).toFixed(2)}</span>
                    </div>

                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                        <span>Quantity</span>
                        <span className="text-white">{item.count || 1}</span>
                    </div>

                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                        <span>Status</span>
                        <span className="text-xs text-green-500">
                            Completed
                        </span>
                    </div>

                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                        <span>Shipping</span>
                        <span className={`text-xs ${
                            item.shipping ? 
                                (item.shipping.status === 'delivered' ? 'text-green-500' :
                                 item.shipping.status === 'shipped' ? 'text-blue-500' :
                                 item.shipping.status === 'in_transit' ? 'text-orange-500' :
                                 'text-gray-500') :
                            'text-gray-500'
                        }`}>
                            {item.shipping ? item.shipping.status : 'No Shipping'}
                        </span>
                    </div>

                    <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                        <span>Date</span>
                        <span className="text-white">{formatDate(item.created_at.seconds)}</span>
                    </div>
                </div>
            </div>

            <div className="w-full text-sm mt-3">
                <button className="text-white border-[1px] border-gray w-full h-[40px]" onClick={showReceipt}>
                    Order Receipt
                </button>

                <button className="flex mt-3 items-center justify-center mr-2 text-white border-white border-[1px] bg-primary w-full h-[40px]"
                    onClick={setMessageToSeller}
                >
                    View Chat
                </button>

                {/* Shipping Tracking Button */}
                {(item.shipping || item.tracking_number) && (
                    <button
                        onClick={() => setShowShippingDialog(true)}
                        className="text-blue-500 border-[1px] border-blue-500 w-full h-[40px] hover:bg-blue-500 hover:text-white mt-3"
                    >
                        Track Shipping
                    </button>
                )}
            </div>

            {/* Shipping Tracking Dialog */}
            {showShippingDialog && (
                <DialogShippingTracking
                    isOpen={showShippingDialog}
                    onClose={() => setShowShippingDialog(false)}
                    saleData={item}
                    userRole={activeTab === 'purchased' ? 'buyer' : 'seller'}
                />
            )}
        </div>
    )
}

const SentItems = ({ items, activeTab }) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [currentMobilePage, setCurrentMobilePage] = useState(1)
    const [showReceiptModal, setShowReceiptModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedCard, setSelectedCard] = useState(null)

    const openReceiptModal = (item, card) => {
        setSelectedItem(item)
        setSelectedCard(card)
        setShowReceiptModal(true)
    }

    return (
        <>
            {
                items.length > 0 ?
                    <>
                        {
                            selectedItem && selectedCard &&
                            <DialogReceipt
                                item={selectedItem}
                                card={selectedCard}
                                open={showReceiptModal}
                                onClose={() => setShowReceiptModal(false)}
                                type={activeTab}
                            />
                        }

                        <div className="max-lg:hidden">
                            <div className="w-full overflow-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-[#2E2E2E] border-[1px] border-gray py-3 text-sm text-[#717171]">
                                            {
                                                fields.map((item, index) =>
                                                    <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}`}>
                                                        {item}
                                                    </th>
                                                )
                                            }
                                        </tr>
                                    </thead>

                                    <div className="pt-1" />
                                    <tbody className="text-white space-y-1 text-sm">
                                        {
                                            items.slice(itemsPerPage * (currentPage - 1), itemsPerPage * currentPage).map((item, index) =>
                                                <SentItem
                                                    item={item}
                                                    key={`offer-item-sent-${currentPage}-${item.title}-${index}`}
                                                    activeTab={activeTab}
                                                    onOpenReceipt={openReceiptModal}
                                                />
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div >

                            <div className="mt-9">
                                <Pagination itemsPerPage={itemsPerPage} totalItems={items.length} onPageChange={(value) => setCurrentPage(value)} />
                            </div>
                        </div>

                        <div className="lg:hidden">
                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-5">
                                {
                                    items.slice(3 * (currentMobilePage - 1), 3 * currentMobilePage).map(item =>
                                        <MobileSentItem item={item} key={`${activeTab}-${item.id}`} activeTab={activeTab} onOpenReceipt={openReceiptModal} />
                                    )
                                }
                            </div>

                            <div className="mt-9">
                                <Pagination itemsPerPage={3} totalItems={items.length} onPageChange={(value) => setCurrentMobilePage(value)} />
                            </div>
                        </div>
                    </>
                    :
                    <div className="mt-6 w-full text-center text-white text-lg">
                        No listings {activeTab}
                    </div>
            }
        </>
    )
}

const PurchaseSaleHistory = () => {
    const [loadingData, setLoadingData] = useState(false)
    const { user, getUpdatedUserData } = useAuth()
    const [initialData, setUserInitialData] = useState()
    const [loading, setLoading] = useState(true)
    const [activeTab, setActiveTab] = useState('purchased')
    const [sentItems, setSentItems] = useState([])
    const [receivedItems, setReceivedItems] = useState([])

    useEffect(() => {
        if (user) {
            // Debug the raw data first
            debugSalesData(user.uid).then((rawData) => {
                console.log('Cart.js - Raw sales data:', rawData);
                if (rawData.length > 0) {
                    console.log('Cart.js - Sample sale structure:', rawData[0]);
                }
            });
            
            getPurchasedListings(user.uid).then((data) => {
                console.log('Cart.js - Purchase data:', data);
                setSentItems(data);
            }).catch(error => {
                console.error('Error loading purchase data:', error);
            })
        }
    }, [user])

    useEffect(() => {
        if (user) {
            setLoadingData(true)
            if (activeTab === 'purchased') {
                setSentItems([]);
                getPurchasedListings(user.uid).then((data) => {
                    setSentItems(data)
                    setLoadingData(false)
                    console.log("Cart.js - Purchase items:", data)
                }).catch(error => {
                    console.error('Error loading purchase data:', error);
                    setLoadingData(false);
                })
            } else {
                setReceivedItems([]);
                getSoldListings(user.uid).then((data) => {
                    setReceivedItems(data)
                    setLoadingData(false)
                    console.log("Cart.js - Sales items:", data)
                    if (data.length > 0) {
                        console.log("Cart.js - Sample sold item:", data[0]);
                    }
                }).catch(error => {
                    console.error('Error loading sales data:', error);
                    setLoadingData(false);
                })
            }
        }
    }, [activeTab])

    return (
        // !loading &&
        <div>
            <ProfileTitle />

            <ProfileTabs activeTab="Purchase/Sale History" />

            <div className="lg:flex items-center justify-between gap-6 mt-9 mb-6">
                <span className="block uppercase text-primary text-[12px] max-lg:mb-8">Purchase/Sale History</span>

                <div className="flex">
                    <button
                        className={`w-[208px] h-[45px] mr-4 text-sm border-[1px] ${activeTab === 'purchased' ? 'border-primary text-black bg-white' : 'text-white  border-gray bg-[#1D1D1D] '}`}
                        onClick={() => setActiveTab('purchased')}
                    >
                        Purchase History
                    </button>

                    <button
                        className={`w-[208px] h-[45px] text-sm border-[1px] ${activeTab === 'sold' ? 'border-primary text-black bg-white' : 'text-white  border-gray bg-[#1D1D1D] '}`}
                        onClick={() => setActiveTab('sold')}
                    >
                        Selling History
                    </button>
                </div>
            </div>


            {/* {
                activeTab === 'purchased' ?
                    <div className="w-full overflow-auto">
                        <SentItems items={sentItems} activeTab={activeTab} />
                    </div>
                    :
                    <div className="w-full overflow-auto">
                        <SentItems items={receivedItems} activeTab={activeTab} />
                    </div>
            } */}

            {loadingData ? (
                <div className="text-white text-center">Loading...</div>
            ) : (
                <SentItems items={activeTab === 'purchased' ? sentItems : receivedItems} activeTab={activeTab} />
            )}
        </div>
    )
}

export default PurchaseSaleHistory